<div class="max-app-width mx-auto my-5 row entity-tree-page" >
  @if (ngxTreeConfig.showTree) {
    <div class="col-12 col-lg-3 " >
      <div class="h-100">
        <!--            <tree-root #treeCmp *ngIf="tree.nodes.length" [nodes]="tree.nodes" [options]="tree.options" [focused]="true" (initialized)="initializedTree()">-->
        <!--                <ng-template #treeNodeTemplate let-node let-index="index">-->
        <!--                   <div (click)="loadNode(node)">-->
        <!--                       <span>{{node.data.name}}</span>-->
        <!--                        <span>({{node.data.count}})</span>-->
      <!--                   </div>-->
    <!--                </ng-template>-->
  <!--            </tree-root>-->
</div>
</div>
}

@if ((ngxTreeConfig.tabsMode)) {
  <div>
    <mat-tab-group>
      @for (item of entityTreeData | keyvalue; track item) {
        <mat-tab label="{{item.value.title | translate}}">
          <tree-accordion [entityTreeData]="{'key': item.value}" [showTitle]="ngxTreeConfig.showTitle"></tree-accordion>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
} @else {
  @if ((!ngxTreeConfig.showInline && !ngxTreeConfig.accordionMode)) {
    <div class="col main" >
      @for (item of entityTreeData | keyvalue; track item) {
        <section  [id]="'tree-section' + item.key" >
          <h4>{{item.value.title}}</h4>
<!--          @if ("") {-->
<!--            <ul class="row">-->
<!--              @for (link of item.value.children; track link) {-->
<!--                <li class="col-12 col-lg-6">-->
<!--                  @if (!ngxTreeConfig.sendEvent) {-->
<!--                    <a class="entity-item-title" [routerLink]="'/' + link.typeVar + '/page/' + link.uri ">{{link.title}}</a>-->
<!--                  }-->
<!--                  @if (ngxTreeConfig.sendEvent) {-->
<!--                    <span class="entity-item-title" (click)="itemSelect(link.entity_var)" >{{link.title}}</span>-->
<!--                  }-->
<!--                </li>-->
<!--              }-->
<!--            </ul>-->
<!--          }-->
        </section>
      }
    </div>
  } @else {
    @if (!ngxTreeConfig.showInline) {
      <div class="col main">
        @for (item of entityTreeData | keyvalue: returnZero; track item) {
          <section class="mb-3"  [id]="'tree-section' + item.key">
            <mat-accordion class="example-headers-align">
              <mat-expansion-panel >
                <mat-expansion-panel-header>
                  <mat-panel-title>{{item.value.title}}</mat-panel-title>
                </mat-expansion-panel-header>
                <ul>
                  @for (link of item.value.children; track link) {
                    <li >
                      @if (!ngxTreeConfig.sendEvent) {
                        <a class="entity-item-title" [routerLink]="'/' + link.typeVar + '/page/' + link.uri ">{{link.title}}</a>
                      }
                      @if (ngxTreeConfig.sendEvent) {
                        <span class="entity-item-title" (click)="itemSelect(link.entity_var)" >{{link.title}}</span>
                      }
                    </li>
                  }
                </ul>
              </mat-expansion-panel>
            </mat-accordion>
          </section>
        }
      </div>
    } @else {
      <div class="col main">
        <tree-accordion [entityTreeData]="entityTreeData" [showTitle]="ngxTreeConfig.showTitle"></tree-accordion>
      </div>
    }
  }
}


</div>
